import { Backdrop, Box, CircularProgress, Skeleton } from "@mui/material";

const FullScreenLoader = ({ open }: fullScreenLoaderProps) => {
  return (
    <Backdrop
      sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularProgress color="secondary" />
    </Backdrop>
  );
};
export const ZIndexFullScreenLoader = ({ open }: fullScreenLoaderProps) => {
  return (
    <Backdrop
      sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 10000000 }}
      open={open}
    >
      <CircularProgress color="secondary" />
    </Backdrop>
  );
};

export const SkeletonLoader: React.FC<{ count: number }> = ({ count }) => {
  const skeletons = Array.from({ length: count }, (_, index) => (
    <Box
      key={index}
      style={{
        textDecoration: "none",
        margin: 15,
        borderRadius: "20px",
        transition: "transform 0.8s",
      }}
    >
      <Skeleton
        variant="rectangular"
        style={{ width: "300px", height: "460px", borderRadius: "20px" }}
      />
    </Box>
  ));

  return <>{skeletons}</>;
};
export default FullScreenLoader;

interface fullScreenLoaderProps {
  open: boolean;
}
